import React from "react";
import logoM from "./assets/mobilemintcarcare-logo.svg";

export const Home = () => (
  <>
    <section className="hero is-fullheight-with-navbar mb-5">
      <div className="columns is-vcentered">
        <div className="column fadeLeftMini">
          <img
            src={logoM}
            alt="Mobile Mint Car Care Logo"
            style={{
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
              opacity: "100%",
            }}
          />
        </div>
        <div className="column fadeRightMini">
          <h2>Early-Stage Investment Opportunity</h2>
          <p>
            <span className="fire">MMCC® | Mobile Mint Car Care</span> launched mid-2023 
            as an innovative zero-carbon waterless automotive care service targeting 
            Surrey & Greater London markets.
          </p>
          <p>
            Current Status: 18-month operational period with active partnerships 
            including major retail chain contract and ongoing discussions with 
            leading fuel retailer. Services priced £25-£330 including recently 
            launched mobile ozone odour removal (£50+). Over 1034 cars serviced 
            and growing, featuring advanced PureShield ceramic protection.
          </p>
          <p>
            Business Development: Established partnerships with major retailer 
            (confidential under NDA), automotive dealer relationships, and 
            advanced negotiations with major fuel station network.
          </p>
          <p>
            Investment Opportunity:
          </p>
          <ul>
            <li>Early-stage company with proven partnerships</li>
            <li>Zero-carbon waterless technology differentiation</li>
            <li>Premium service positioning (£25-£330 range)</li>
            <li>Active B2B contract negotiations</li>
            <li>Scalable mobile business model</li>
          </ul>
          <p>
            Seeking investment to capitalize on established partnerships 
            and accelerate market expansion through proven eco-conscious 
            automotive care solutions.
          </p>
          <p>
            <span className="fire">MMCC</span>® is a registered brand of{" "}
            <span className="fire">Mobile Mint Car Care</span>.
          </p>
        </div>
      </div>
    </section>
  </>
);
